/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useRef, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formatMessage } from "devextreme/localization";
import { Button } from "devextreme-react";
import LoadPanel from "devextreme-react/load-panel";
import { showRole, IsPermisionOidRequired } from "../../../../redux/actions";
import { responseRole, responseMiddleware } from "../../../../redux/reducers";
import RoleTableList from "./RoleTable";
import { useScreenSize } from "../../../../utils/media-query";
import UsingIntl from "../../../../services/using_intl";

export default function RolePage() {
  let history = useHistory();
  let dataGrid = useRef(null);
  const { isXSmall } = useScreenSize();
  const [selectedDatas, setSelectedDatas] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();
  const { role } = useSelector(responseRole);
  const { middleware, loading } = useSelector(responseMiddleware);

  useEffect(() => {
    dispatch(IsPermisionOidRequired());
    UsingIntl();
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (!ReadState && ReadState !== undefined)
      ) {
        history.push("/403");
        return;
      }
      dispatch(showRole());
    }
  }, [middleware]);

  const renderActions = ({ data }) => {
    return (
      <div>
        <Button
          icon="detailslayout"
          onClick={() =>
            history.push(`/permissions/role-details/${data.RoleName}`)
          }
          className="button-rounded"
          text={formatMessage("Detail")}
          // stylingMode="text"
        />
      </div>
    );
  };

  const onSelectionChanged = useCallback(
    ({ selectedRowKeys, selectedRowsData }) => {
      // set state not re-render component
      setSelectedDatas(selectedRowsData);
      setSelectedRowKeys(selectedRowKeys);
    },
    []
  );

  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("RoleList")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/permissions" className={"breadcrumb-item"}>
            {formatMessage("Permission")}
          </Link>

          <span className={"breadcrumb-item active"}>
            {formatMessage("RoleList")}
          </span>
        </div>
      </div>
      <div className={"section"}>
        <div className={"section-body"}>
          {/* Role list */}
          <RoleTableList
            dataGrid={dataGrid}
            dataSource={role}
            onSelectionChanged={onSelectionChanged}
            selectedRowKeys={selectedRowKeys}
            selectedDatas={selectedDatas}
            isXSmall={isXSmall}
            renderActions={renderActions}
            middleware={middleware}
          />
        </div>
      </div>
    </div>
  );
}
